import styled from 'styled-components';
import { ReactComponent as ShareIconSVG } from '../../images/share-icon.svg';

export const Button = styled.button`
  background: none;
  border: none;
  outline: none;

  &:hover {
    cursor: pointer;
  }
`;

export const ShareIcon = styled(ShareIconSVG)`
  width: 20px;
  height: 20px;

  circle {
    fill: none;
  }

  @media print {
    display: none;
  }
`;
